<rt-dialog-body variant="default no-padding white" overflow-hidden>
  <div layout-vertical layout-full-width>
    <div class="header" layout-centered padding-small-x>
      @if (hasBadge) {
        <rt-badge
          color="default"
          text="{{
            (availableFromPlan() === BillingPlanTier.Grow
              ? 'app.pricing.grow'
              : availableFromPlan() === BillingPlanTier.Optimize
                ? 'app.pricing.optimize'
                : ''
            ) | translate
          }}"
        />
      }
      <rt-heading variant="heading large" margin-left-small-x>
        {{ headingTranslationKey() | translate }}
      </rt-heading>
    </div>
    <rt-feature-guard-content
      [featureData]="featureData"
      [canUpgrade]="canUpgrade"
      [availableFromPlan]="availableFromPlan()"
      [availableInNewPlans]="availableInNewPlans"
      (openPlanPicker)="openPlanPicker()"
    />
  </div>
</rt-dialog-body>
